import React, {useMemo} from 'react';
import type {SxProps} from '@mui/material';
import {useLocalization} from 'localization';
import {useShortcut} from 'services/shortcuts';
import {ActionButtonV2} from 'components/button/ActionButtonV2';
import {useWorkToggleContext} from '../../../contexts';

export const WorkCardTitle: React.FC = () => {
  const {t} = useLocalization();
  const {workHidden, onToggle} = useWorkToggleContext();

  useShortcut('toggleWork', () => onToggle());

  const sx: SxProps = useMemo(
    () => ({
      paddingX: workHidden ? '1px' : 'inherit',
      minWidth: '45px',
    }),
    [workHidden],
  );

  return (
    <ActionButtonV2
      color={'secondary'}
      onClick={() => onToggle()}
      size={'small'}
      sx={sx}>
      {t('page.metadata.work.title')}
    </ActionButtonV2>
  );
};
